<template lang="pug">
  .edit-sub-payment.narrow-modal-body
    SectionTitle(text="Edit Subscription Payment Method").app-modal-title
    PaymentProfileList

    .row.text-center
      hr
      PaymentAddNewBtn(@new-payment-click="addModalBackAction")

    .row
      SubmitButtons(
        submit-text="Save"
        :submit-method="updateSubPayment"
        :submit-disabled="savingSub"
        cancel-text="Cancel"
        :cancel-method="cancel"
      )
  
</template>

<script>
  import { mapState, mapActions, mapGetters } from "vuex";
  import SectionTitle from "../../../SectionTitle";
  import PaymentAddNewBtn from "../../../PaymentProfiles/PaymentAddNewBtn";
  import SubmitButtons from "../../../SubmitButtons";
  import PaymentProfileList from "../../../PaymentProfiles/PaymentProfileList";

  export default {
    name: "EditAutoDeliveryPayment",
    components: {
      PaymentProfileList,
      SubmitButtons,
      PaymentAddNewBtn,
      SectionTitle
    },

    computed: {
      ...mapState('subscriptions', [
        'savingSub',
        'subInEdit'
      ]),

      ...mapState('payments', [
        'selectedProfileId',
        'lastSavedProfile'
      ]),

      ...mapGetters('subscriptions', [
        'activeSubscriptions'
      ])
    },

    methods: {
      ...mapActions('modal', [
        'hideModal'
      ]),

      ...mapActions('subscriptions', [
        'updateSubscription',
        'updateSubsToUpdate'
      ]),

      ...mapActions('payments', [
        'clearSelectedProfile',
        'updateSubsModal',
        'updateLastSavedProfile'
      ]),

      addModalBackAction() {
        this.$store.commit('modal/pushModalStepBackAction', 'subscriptions/editAutoDeliveryPaymentModal');
      },

      updateSubPayment() {
        var payload = {
          sub_id: this.subInEdit.id,
          changes: {
            payment_id: this.selectedProfileId
          }
        };

        this.updateSubscription(payload).then(this.cleanUp);
      },

      cancel() {
        this.cleanUp();
      },

      cleanUp() {
        this.hideModal();
        this.clearSelectedProfile();
        //- when ever we save the sub we need to check if there is a new payment profile and its set to default, if so
        //- prompt the user if they would like to update all their active subs with it (filter out sub just updated)
        if (this.lastSavedProfile.paymentProfileId && this.lastSavedProfile.is_default && this.activeSubscriptions.length) {
          //- filter current sub out of active subs
          let subsToUpdate = this.activeSubscriptions.filter(sub => sub.id != this.subInEdit.id);
          this.updateSubsToUpdate(subsToUpdate);
          this.updateSubsModal();
        }
      }
    }
  }
</script>

<style scoped lang="stylus">
  .new-profile-btn
    padding-bottom 2em

</style>